<script>
    import { fly } from "svelte/transition";
    import { NoticeBar } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body nopadding">
        <NoticeBar>默认</NoticeBar>
        <NoticeBar color="alert">警告</NoticeBar>
        <NoticeBar color="error">错误</NoticeBar>
        <NoticeBar color="info">信息</NoticeBar>
    </div>
    <h4 class="example-title">超长滚动</h4>
    <div class="example-body nopadding">
        <NoticeBar
            >粤B****5投保成功后获得了3次代驾服务  京B****2投保成功后获得了1个会员礼包  粤H****3投保成功后获得了2次道路救援服务  浙B****6投保成功后获得了1次年检代办服务  皖A****8投保成功后获得了2次道路救援服务  陕D****E投保成功后获得了1个健康礼包  沪A****2投保成功后获得了2次优惠洗车服务  浙A****F投保成功后获得了2次道路救援服务  粤B****5投保成功后获得了3次代驾服务  京B****2投保成功后获得了1个会员礼包</NoticeBar
        >
        <NoticeBar color="alert"
            >适用于当前页面内信息的通知，是一种较醒目的页面内通知方式。</NoticeBar
        >
        <NoticeBar color="error"
            >适用于当前页面内信息的通知，是一种较醒目的页面内通知方式。</NoticeBar
        >
        <NoticeBar color="info"
            >适用于当前页面内信息的通知，是一种较醒目的页面内通知方式。</NoticeBar
        >
    </div>
    <h4 class="example-title">可关闭</h4>
    <div class="example-body nopadding">
        <NoticeBar closeable
            >适用于当前页面内信息的通知，是一种较醒目的页面内通知方式。</NoticeBar
        >
        <NoticeBar color="alert" closeable>警告</NoticeBar>
        <NoticeBar color="error" closeable>错误</NoticeBar>
        <NoticeBar color="info" closeable>信息</NoticeBar>
    </div>
</div>

<style lang="less">
    @import "./example.less";
    .nopadding {
        padding: 0;
    }
</style>
